import RNG from '../rng';
export default class RNGMathRandom extends RNG {
    get name() {
        return 'default';
    }
    next() {
        return Math.random();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    seed(_seed, _opts) {
        // intentionally empty
    }
    clone() {
        return new RNGMathRandom();
    }
}
//# sourceMappingURL=math-random.js.map